export const WebUiKycDisapprovedAlertEnI18n = {
    type: `warning`,
    message: `We had identified issues to validate your personal information. Please <a class="edit-link"> review your data</a>`,
};
